/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GraphTagList } from '../../models/graph-tag-list';
import { GraphTagSearch } from '../../models/graph-tag-search';
import { SortDirection } from '../../models/sort-direction';
import { TagGroupName } from '../../models/tag-group-name';
import { TagSortFieldName } from '../../models/tag-sort-field-name';

export interface GetTagsByGroup$Json$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The value of the group for a group field (can be null)
 */
  groupValue?: string;

/**
 * Indicates the field to use for grouping the data:
 *   * GROUP : the tag group
 */
  groupName?: TagGroupName & any;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the tag name
 *   * ALIAS : the tag alias
 *   * UNIT : the tag unit
 *   * LAST_VALUES_LAST_VALUE_DATETIME : the tag last value datetime
 *   * LAST_VALUES_LAST_VALUE : the tag last value
 *   * VALUE_TYPE : the tag value type
 */
  sortFieldName?: TagSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search graph tags
     */
    body?: GraphTagSearch
}

export function getTagsByGroup$Json(http: HttpClient, rootUrl: string, params: GetTagsByGroup$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphTagList>> {
  const rb = new RequestBuilder(rootUrl, getTagsByGroup$Json.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('groupValue', params.groupValue, {});
    rb.query('groupName', params.groupName, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GraphTagList>;
    })
  );
}

getTagsByGroup$Json.PATH = '/stations/{uid}/graph/tags/group/search';
